/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_DismissInputs */

const en_btn_dismiss = /** @type {(inputs: Btn_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss`)
};

/**
* | output |
* | --- |
* | "Dismiss" |
*
* @param {Btn_DismissInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const btn_dismiss = /** @type {((inputs?: Btn_DismissInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_DismissInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_btn_dismiss(inputs)
});